import { useTheme } from '@mui/material';
import classnames from 'classnames';
import { getBrandAlpha3Codes } from 'lib/config/index';
import PropTypes from 'prop-types';
import { useContext } from 'react';

import { CruiseSearchContext } from 'contexts/CruiseSearchContext';

import {
  Container,
  Label,
  LoggedCrownAndAnchor,
  LoggedHeaderContainer,
  LoggedLabelAs,
  LoggedLabelId,
  LoggedLabelSwitch,
  LoggedLabelSymbol,
  LoggedNoOffersInfo,
  LoggedNoOffersInfoMessage,
  LoggedOffersContainer,
  LoggedSignInNow,
  LoggedSwitch,
  LoggedWelcomeInfo,
} from './LoggedInfo.styled';

import { TYPES_SIGNIN } from '../constants';
import MyOffers from '../MyOffers';

function LoggedInfo({
  id,
  typeSignIn,
  onClickCrownAnchor,
  onClickSignNow,
  onClickSwitchAccount,
}) {
  const { brand, globalization, targetedOffers } = useContext(CruiseSearchContext);
  const { palette } = useTheme();

  const { filtersDictionary } = globalization?.dictionaries || {};
  const {
    labelTargetedOffersLoggedAS,
    labelTargetedOffersWelcomeBack,
    labelTargetedOffersShowOffers,
    labelTargetedOffersNoOffers,
    labelTargetedOffersPrelinkCrownAnchor,
    actionTargetedOffersSignIn,
    actionTargetedOffersSwitchAccount,
  } = filtersDictionary;

  const brandAlpha3Codes = getBrandAlpha3Codes()


  const loggedInfoLabelsByBrands = {
    labelTargetedNoOffersEmail: filtersDictionary[`labelTargetedOffersNoOffersEmail_${brandAlpha3Codes[brand]}`],
    actionTargetedOfferslink: filtersDictionary[`actionTargetedOfferslinkCrownAnchor_${brandAlpha3Codes[brand]}`],
  }
  

  const [typeEmail] = TYPES_SIGNIN;

  const isEmail = () => typeSignIn === typeEmail;

  const getTargetedOffers = () =>
    Array.isArray(targetedOffers) ? targetedOffers : [];

  const getNoOfferLabel = () =>
    isEmail() ? loggedInfoLabelsByBrands.labelTargetedNoOffersEmail : labelTargetedOffersNoOffers;

  const switchHandler = e => {
    e.preventDefault();
    onClickSwitchAccount();
  };

  const classes = classnames({
    isMobile: true,
  });

  return (
    <>
      <Container>
        <LoggedHeaderContainer>
          <LoggedLabelAs palette={palette}>
            {labelTargetedOffersLoggedAS}
          </LoggedLabelAs>
          <LoggedLabelId palette={palette}>
            &nbsp;{id}&nbsp;
          </LoggedLabelId>
          <LoggedSwitch>
            <LoggedLabelSymbol palette={palette} >
              (
            </LoggedLabelSymbol>
            <LoggedLabelSwitch href="#" onClick={switchHandler}>
              {actionTargetedOffersSwitchAccount}
            </LoggedLabelSwitch>
            <LoggedLabelSymbol palette={palette}>
              )
            </LoggedLabelSymbol>
          </LoggedSwitch>
        </LoggedHeaderContainer>
        <LoggedWelcomeInfo>
          <Label variant="label2" component="span" className={classes}>
            {labelTargetedOffersWelcomeBack}&nbsp;
            {isEmail() && (
              <>
                <span>{labelTargetedOffersPrelinkCrownAnchor}</span>
                <LoggedCrownAndAnchor onClick={() => onClickCrownAnchor()}>
                  &nbsp;{loggedInfoLabelsByBrands.actionTargetedOfferslink}
                </LoggedCrownAndAnchor>
              </>
            )}
          </Label>
          {!isEmail() && (
            <Label variant="label2" component="span" className={classes}>
              {labelTargetedOffersShowOffers}:
            </Label>
          )}
        </LoggedWelcomeInfo>
        {getTargetedOffers().length == 0 ? (
          <LoggedOffersContainer>
            <LoggedNoOffersInfo>
              <LoggedNoOffersInfoMessage>
                {getNoOfferLabel()}
                {isEmail() && (
                  <LoggedSignInNow onClick={() => onClickSignNow()}>
                    {actionTargetedOffersSignIn}
                  </LoggedSignInNow>
                )}
              </LoggedNoOffersInfoMessage>
            </LoggedNoOffersInfo>
          </LoggedOffersContainer>
        ) : (
          <MyOffers />
        )}
      </Container>
    </>
  );
}

LoggedInfo.propTypes = {
  id: PropTypes.string.isRequired,
  typeSignIn: PropTypes.string.isRequired,
  onClickCrownAnchor: PropTypes.func,
  onClickSignNow: PropTypes.func,
  onClickSwitchAccount: PropTypes.func,
};

export default LoggedInfo;
